import { useRef } from 'react';

export function useRefUpdating<T>(result: T) {
  const ref = useRef(result);

  if (ref.current !== result) {
    ref.current = result;
  }

  return ref;
}

export function useRefAutoUpdate<T, K extends keyof T>(
  ref: React.MutableRefObject<T>,
  key: K,
  result: T[K],
) {
  if (ref.current[key] !== result) {
    ref.current[key] = result;
  }
}
